module.exports = "<ng-template ngFor let-breadcrumb [ngForOf]=\"breadcrumbs\" let-last=last>\n  <li class=\"breadcrumb-item\"\n      [ngClass]=\"{active: last}\">\n    <a (click)=\"trackBreadCrumbEvent($event)\" [routerLink]=\"breadcrumb.url\">{{breadcrumb.label.title}}</a>\n  </li>\n</ng-template>"


//////////////////
// WEBPACK FOOTER
// /Users/sensorflow/Documents/legacy/kalinda/Dashboard/sensorflow-dashboard/src/app/shared/breadcrumb.component.html
// module id = ../../../../../src/app/shared/breadcrumb.component.html
// module chunks = main